/*
  Safir flavor engine. Tiny, no libraries.

  Any element with data-sr-flavor-set="pina|strawberry|passion" becomes a
  flavor switch: clicking it sets <html data-sr-flavor>, which recolors
  everything built on --sr-accent / --sr-tint (see assets/sr-base.css).
  The choice is remembered for the visit, so the next page opens in the
  same flavor. Sections can listen for the 'sr:flavor' event to swap their
  own content (photos, links, labels).

  The starting flavor is applied before this file loads, by the inline
  script in sections/sr-style.liquid, so there is no flash of the wrong
  color.
*/
(() => {
  const root = document.documentElement;
  const KEY = 'sr-flavor';
  const FLAVORS = ['pina', 'strawberry', 'passion'];

  const syncPressed = (flavor) => {
    document.querySelectorAll('[data-sr-flavor-set]').forEach((el) => {
      if (el.tagName === 'BUTTON' || el.getAttribute('role') === 'button') {
        el.setAttribute('aria-pressed', String(el.dataset.srFlavorSet === flavor));
      }
    });
  };

  const setFlavor = (flavor, { remember = true } = {}) => {
    if (!FLAVORS.includes(flavor)) return;
    root.dataset.srFlavor = flavor;
    syncPressed(flavor);
    if (remember) {
      try {
        sessionStorage.setItem(KEY, flavor);
      } catch (e) {
        /* private mode: the flavor just isn't remembered */
      }
    }
    document.dispatchEvent(new CustomEvent('sr:flavor', { detail: { flavor } }));
  };

  window.Safir = window.Safir || {};
  window.Safir.setFlavor = setFlavor;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-sr-flavor-set]');
    if (!trigger) return;
    setFlavor(trigger.dataset.srFlavorSet);
  });

  // The theme editor re-renders sections in place; keep their switches in sync.
  document.addEventListener('shopify:section:load', () => syncPressed(root.dataset.srFlavor));

  syncPressed(root.dataset.srFlavor);

  // Turn the color fade on only after the first paint (see .sr-ready).
  requestAnimationFrame(() => requestAnimationFrame(() => root.classList.add('sr-ready')));
})();
